
















import { Component, Vue, Prop } from 'vue-property-decorator';
import { qrcode, svg2url } from 'pure-svg-code';
import moment from 'moment';
import { Organ } from '@/types';

@Component
export default class CIndex extends Vue {
  @Prop() organ!: Organ;
  @Prop() pid!: string;
  @Prop() pTitle!: string;
  @Prop() oname!: string;
  @Prop() donorname!: string;

  get timeStr() {
    const currentDate = moment();
    const currentYear = currentDate.format('YYYY');;
    const currentMonth = currentDate.format('MM'); // 注意：moment.js 中的月份是从 0 开始的，因此需要加 1
    const currentDay = currentDate.format('DD');;
    return `${currentYear}年${currentMonth}月${currentDay}日`;
  }

  get qrcodeImg() {
    return this.buildQrcode(`https://apps.wechatpay.com.hk/charity/index.shtml?pid=${this.pid}`);
  }

  get info() {
    return `感謝你於${this.timeStr}參與騰訊久久公益節，為${this.pTitle}進行捐贈。邀請您把活動分享給更多人，善心唔使等，掃碼即刻捐！`;
  }

  /**
  * 生成二维码
  */
  buildQrcode(str: string) {
    let code = '';
    const qrSvgStr = qrcode({
      content: str,
      padding: 0,
      color: '#000000',
      background: '#ffffff',
      ecl: 'M',
    });
    code = svg2url(qrSvgStr);

    return code;
  }
}
